<template>
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00024 19.0356H12.9985L12.9985 12.8887H19.1455V7.89038L12.9985 7.89038L12.9985 1.74365H8.00024L8.00024 7.89038L1.85352 7.89038V12.8887H8.00024L8.00024 19.0356Z" fill="currentColor"/>
    </svg>
</template>